import { render, staticRenderFns } from "./CurrentCustomers.vue?vue&type=template&id=f602b65c&scoped=true"
import script from "./CurrentCustomers.vue?vue&type=script&lang=js"
export * from "./CurrentCustomers.vue?vue&type=script&lang=js"
import style0 from "./CurrentCustomers.vue?vue&type=style&index=0&id=f602b65c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f602b65c",
  null
  
)

export default component.exports